<script>
export default {
    name: "CheckBox"
}
</script>
<template>
    <svg role="img" aria-label="Checkbox"  viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8477 6.59766H11.8125L12.4102 6L11.25 4.80469L10.6523 5.40234L6.75 9.33984L4.5 7.08984L3.30469 8.25L6.75 11.6953L11.8477 6.59766Z" fill="#fff"/>
    </svg>
</template>
